import { call, put, takeLeading } from 'typed-redux-saga'
import { realtyPatentsApi, RealtyPatentsNS, realtyPatentsSlice } from 'Pages/registratorCabinet'
import { errorHandler, loadersSlice } from 'Modules'
import { FormNames } from 'Constants/FormNames'

export function* getRealtyPatents(action: RealtyPatentsNS.getRealtyPatents) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(realtyPatentsApi.getRealtyPatents, action.payload)
		yield* put(realtyPatentsSlice.actions.setRealtyPatents(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* createRealtyPatent(action: RealtyPatentsNS.createRealtyPatent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, data, callback } = action.payload
		yield* call(realtyPatentsApi.createRealtyPatent, id, data)
		const res = yield* call(realtyPatentsApi.getRealtyPatents, id)
		callback?.()
		yield* put(realtyPatentsSlice.actions.setRealtyPatents(res))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.REGISTRATOR_CABINET.PATENT)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* updateRealtyPatent(action: RealtyPatentsNS.updateRealtyPatent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { patentId, id, data, callback } = action.payload
		yield* call(realtyPatentsApi.updateRealtyPatent, patentId, id, data)
		const res = yield* call(realtyPatentsApi.getRealtyPatents, patentId)
		yield* put(realtyPatentsSlice.actions.setRealtyPatents(res))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error, FormNames.REGISTRATOR_CABINET.PATENT)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* deleteRealtyPatent(action: RealtyPatentsNS.deleteRealtyPatent) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { patentId, id, callback } = action.payload
		yield* call(realtyPatentsApi.deleteRealtyPatent, patentId, id)
		const res = yield* call(realtyPatentsApi.getRealtyPatents, patentId)
		yield* put(realtyPatentsSlice.actions.setRealtyPatents(res))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* realtyPatentsSaga() {
	yield* takeLeading(realtyPatentsSlice.actions.getRealtyPatents.type, getRealtyPatents)
	yield* takeLeading(realtyPatentsSlice.actions.createRealtyPatent.type, createRealtyPatent)
	yield* takeLeading(realtyPatentsSlice.actions.updateRealtyPatent.type, updateRealtyPatent)
	yield* takeLeading(realtyPatentsSlice.actions.deleteRealtyPatent.type, deleteRealtyPatent)
}
